import React from "react";
import {isAllowed} from '../authentication';

const Empty = (props) => {
    isAllowed(props);
    return(<>
        {props.children}
    </>)
}

export default Empty;